// import { Sparkle28Filled } from "@fluentui/react-icons";

// export const AnswerIcon = () => {
//     return <Sparkle28Filled primaryFill={"rgba(115, 118, 225, 1)"} aria-hidden="true" aria-label="Answer logo" />;
// };

import logo from "../../assets/logo-noglow.png";

export const AnswerIcon = () => {
    return <img src={logo} alt="Answer logo" aria-label="Answer logo" style={{ width: "28px", height: "28px" }} />;
};
